module.exports = __webpack_public_path__ + "img/img43.aa2cc8eb.svg";